import { Box, Heading, Text, SimpleGrid } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

const OurLeaders = ({ data }) => {
  const navigate = useNavigate();
  const baseUrl = process.env.REACT_APP_API_URL?.replace("/api", "") || "";

  // Helper function to ensure URLs have proper protocol
  const formatUrl = (url) => {
    if (!url) return null;
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    return `https://${url}`;
  };

  const allLeaders =
    data?.leaderProfile?.map((leader, index) => {
      // Handle image URL - if it already has full URL, use it directly, otherwise prepend baseUrl
      let imageUrl = null;
      if (leader?.image?.url) {
        if (
          leader.image.url.startsWith("http://") ||
          leader.image.url.startsWith("https://")
        ) {
          imageUrl = leader.image.url; // Already has full URL
        } else {
          imageUrl = `${baseUrl}${leader.image.url}`; // Need to prepend baseUrl
        }
      }

      return {
        name: leader?.name,
        position: leader?.designation,
        image: imageUrl,
        bio: leader?.bio,
        profileLink: leader?.profileLink,
        // Add social media links matching your CMS field names with proper formatting
        facebook: formatUrl(leader?.facebookLink),
        twitter: formatUrl(leader?.twiterLink), // Note: using 'twiterLink' as shown in your CMS
        linkedin: formatUrl(leader?.linkedinLink),
      };
    }) || [];

  return (
    <Box py={{ base: "20px", md: "30px" }}>
      {/* Header Section */}
      <Box textAlign="center" mb={{ base: 8, md: 12 }}>
        <Heading
          as="h1"
          fontSize={{ base: "2xl", md: "4xl" }}
          fontWeight="bold"
          color="#000B8C"
          lineHeight="1.2"
        >
          Our{" "}
          <Text as="span" color="gray.700">
            people, our power
          </Text>
        </Heading>

        <Text
          fontSize={{ base: "md", md: "lg" }}
          color="gray.500"
          fontStyle="italic"
          mb={8}
        >
          Inclusive. Inspired. Impact-Driven.
        </Text>

        {/* Description Paragraphs */}
        <Box maxW="6xl" mx="auto" textAlign="justify" spacing={6}>
          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            lineHeight="1.2"
            mb={6}
          >
            At Business Automation, we believe that great technology begins with
            great people. Behind every innovation, every solution, and every
            breakthrough is a passionate team of problem-solvers, dreamers, and
            builders. We are proud of our diverse, multidisciplinary team—a
            dynamic mix of seasoned professionals, ambitious young talents and
            an increasing number of women.
          </Text>

          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            lineHeight="1.2"
            mb={6}
          >
            We are an equal opportunity employer, dedicated to fostering a safe,
            inclusive, and empowering workplace where every individual has the
            opportunity to learn, lead, and thrive. Our commitment to talent
            development is reflected in our ongoing skill-building programs,
            designed to help team members grow both personally and
            professionally.
          </Text>

          <Text
            fontSize={{ base: "md", md: "lg" }}
            color="gray.600"
            lineHeight="1.2"
            mb={12}
          >
            We also actively collaborate with universities to offer internships
            of varying durations, enabling students to gain real-world
            experience and contribute to meaningful projects. From product
            ideation to customer support,{" "}
            <Text as="span" fontWeight="bold" color="#000B8C">
              our people are our power
            </Text>
            —and the reason we remain as one of the most fulfilling and
            forward-looking workplaces in the Bangladeshi tech sector.
          </Text>
        </Box>
      </Box>
      <SimpleGrid
        columns={{ base: 1, sm: 2, md: 3 }}
        spacing={{ base: 4, sm: 5, md: 6 }}
        maxW="1200px"
        mx="auto"
        mb={{ base: 10, md: 16 }}
      >
        {[
          "/png/jahidul_hasan.png",
          "/png/shoeb_masud.png",
          "/png/biswas.png",
        ].map((src, i) => (
          <Box
            key={i}
            rounded="xl"
            overflow="hidden"
            position="relative"
            // h={{ base: "180px", sm: "220px", md: "400px" }}
            _hover={{ transform: "scale(1.02)" }}
            transition="0.3s"
          >
            <Box
              as="img"
              src={src}
              alt={`Team highlight ${i + 1}`}
              w="100%"
              h="100%"
              objectFit="cover"
              draggable="false"
            />
          </Box>
        ))}
      </SimpleGrid>

      {/* <SimpleGrid
        columns={{ base: 1, sm: 2, lg: 3 }}
        spacing={{ base: 6, md: 8 }}
        maxW="1200px"
        mx="auto"
        justifyItems="center"
      >
        {displayedLeaders.map((leader, index) => (
          <Box
            key={index}
            bg="white"
            rounded="xl"
            overflow="hidden"
            shadow="md"
            position="relative"
            maxW="350px"
            w="100%"
            h={{ base: "450px", sm: "480px", md: "500px" }}
            display="flex"
            flexDirection="column"
            transition="transform 0.3s ease"
            border="1px"
            borderColor="gray.200"
            _hover={{
              transform: "translateY(-5px)",
              shadow: "lg",
            }}
          >
            <Box
              position="relative"
              h={{ base: "300px", sm: "320px", md: "340px" }}
              flexShrink={0}
              overflow="hidden"
            >
              {leader.image ? (
                <Box
                  w="100%"
                  h="100%"
                  backgroundImage={`url(${leader.image})`}
                  backgroundSize="cover"
                  backgroundPosition="center top"
                  backgroundRepeat="no-repeat"
                  onError={(e) => {
                    console.error("Leader image failed to load:", leader.image);
                  }}
                />
              ) : (
                <Box
                  w="100%"
                  h="100%"
                  bg="gray.200"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Text fontSize="lg" color="gray.500">
                    No Image
                  </Text>
                </Box>
              )}
            </Box>

            <Box
              p={{ base: 4, sm: 5, md: 6 }}
              textAlign="center"
              flex="1"
              display="flex"
              flexDirection="column"
              justifyContent="space-between"
            >
              <Box
                flex="1"
                display="flex"
                flexDirection="column"
                justifyContent="center"
              >
                <Heading
                  as="h3"
                  fontSize={{ base: "lg", sm: "xl" }}
                  color="#000B8C"
                  mb={2}
                  fontWeight="bold"
                  lineHeight="1.2"
                  noOfLines={2}
                  textAlign="center"
                >
                  {leader.name}
                </Heading>
                <Text
                  color="#000B8C"
                  fontSize={{ base: "md", sm: "lg" }}
                  mb={3}
                  fontWeight="medium"
                  lineHeight="1.3"
                  noOfLines={2}
                  textAlign="center"
                >
                  {leader.position}
                </Text>
              </Box>
            </Box>
          </Box>
        ))}
      </SimpleGrid> */}
    </Box>
  );
};

export default OurLeaders;
